module.exports = __webpack_public_path__ + "img/ic_success_filled.0b2421d6.png";